import React from "react";
import {
  Balance,
  BalanceTaka,
  Name,
  PictureContainer,
  ProfileHeadingDetails,
  ProfileDetails,
  ProfileHeading,
  ProfileDetailsPart,
  ProfilePartContainer,
  ProfileNameContainer,
  ProfilePartDiv,
  ProfilePicSize,
  ProfilePicture,
  ProfileSummary,
  StatusContainer,
  UserStatus,
  Line1,
} from "./ProfilePart.style";
import useProfile from "../../hooks/useProfile";
import moment from "moment";

const ProfilePart = () => {
  const [userData, isLoading, isError, error] = useProfile();
  console.log(userData);
  return (
    <ProfilePartContainer>
      <ProfilePartDiv>
        {isLoading ? (
          "loading...."
        ) : isError ? (
          <div>{error.message}</div>
        ) : (
          <div>
            <ProfileSummary>
              <ProfilePicture>
                <PictureContainer>
                  <ProfilePicSize>
                    <img src={userData?.user_image} alt="" />
                  </ProfilePicSize>
                  <ProfileNameContainer>
                    <Name>{userData?.full_name}</Name>

                    <Balance>
                      User Level:
                      <BalanceTaka>&nbsp;{userData?.ugleve_name}</BalanceTaka>
                    </Balance>
                    <UserStatus>{userData?.ugleve_name}</UserStatus>
                  </ProfileNameContainer>
                </PictureContainer>

                <StatusContainer></StatusContainer>
              </ProfilePicture>

              <Line1 />

              <ProfileDetails>
                <ProfileDetailsPart>
                  <ProfileHeading>Name</ProfileHeading>

                  <ProfileHeadingDetails>
                    {userData?.full_name || "null"}
                  </ProfileHeadingDetails>
                </ProfileDetailsPart>

                <ProfileDetailsPart>
                  <ProfileHeading>Email</ProfileHeading>
                  <ProfileHeadingDetails>
                    {userData?.email_address || "null"}
                  </ProfileHeadingDetails>
                </ProfileDetailsPart>

                <ProfileDetailsPart>
                  <ProfileHeading>User Level</ProfileHeading>
                  <ProfileHeadingDetails>
                    {userData?.ugleve_name || "null"}
                  </ProfileHeadingDetails>
                </ProfileDetailsPart>
              </ProfileDetails>
              <ProfileDetails>
                <ProfileDetailsPart>
                  <ProfileHeading>User name</ProfileHeading>
                  <ProfileHeadingDetails>
                    {userData?.username || "null"}
                  </ProfileHeadingDetails>
                </ProfileDetailsPart>

                <ProfileDetailsPart>
                  <ProfileHeading>User Id</ProfileHeading>
                  <ProfileHeadingDetails>
                    {userData?.id || "null"}
                  </ProfileHeadingDetails>
                </ProfileDetailsPart>

                <ProfileDetailsPart>
                  <ProfileHeading>User Since</ProfileHeading>
                  <ProfileHeadingDetails>
                    {moment(userData?.created_at).format("DD MMM YYYY")}
                  </ProfileHeadingDetails>
                </ProfileDetailsPart>
              </ProfileDetails>
            </ProfileSummary>
          </div>
        )}
      </ProfilePartDiv>
    </ProfilePartContainer>
  );
};

export default ProfilePart;
